<template>
  <svg viewBox="71.015 19.261 24 24" width="24" height="24">
    <circle cx="83.015" cy="31.261" r="12" fill="#00529A"/>
    <path
      d="M 84.809 30.445 L 89.491 23.509 L 88.201 23.509 L 83.475 29.002 L 80.615 23.509 L 75.346 23.509 L 81.055 31.816 L 75.346 38.451 L 76.636 38.451 L 81.627 32.649 L 85.613 38.451 L 91.338 38.451 L 84.809 30.445 Z M 82.281 31.89 L 81.702 31.062 L 77.101 24.48 L 79.082 24.48 L 82.796 29.792 L 83.374 30.619 L 88.201 37.524 L 86.22 37.524 L 82.281 31.89 Z"
      fill="white"/>
  </svg>
</template>
